import { Box, Stack } from "@mui/material";

// import { AnalyticsSkeletonCard, AnalyticCard } from "@/components/AnalyticCard";
import NextObservationCard from "@/components/NextObservationCard";
import { scrollable } from "@/components/scrollable";
// import { useAnalytics } from "@/services";
import { css, type Theme } from "@/theme";
import { PatientList } from "./patient-list";
import { useLocalStorage } from "react-use";
// import { WORK_OFFLINE } from "@/resources/constants";
// import { createMockAnalytics } from "./patient-list/mocking/patient-list-mocking";
// import { useMemo } from "react";

const styles = {
  analytics: {
    gap: 2,
    px: 3,
    py: 2,
    width: "100vw",
    overflow: "overlay",
    flexShrink: 0, // Prevent the analytics section from shrinking
  },
  analyticsContainer: (compact: boolean) => css`
    display: flex;
    flex-direction: row;
    justify-content: ${compact ? "flex-end" : "space-between"};
    align-items: center;
    width: 100%;
    min-height: ${compact ? "3rem" : "4rem"};
    transition: all 0.3s ease;
    flex-shrink: 0; // Prevent container from shrinking
  `,
  container: css`
    position: relative;
  `,
  handle: (theme: Theme) => css`
    position: absolute;
    left: 50%;
    top: -6px;
    z-index: 10;
    cursor: pointer;
    width: 4.5rem;
    height: 0.75rem;
    background-color: ${theme.palette.primary[300]};
    border-radius: 0.375rem;
  `,
  dot: (theme: Theme) => css`
    min-width: 0.25rem;
    min-height: 0.25rem;
    background-color: ${theme.palette.primary[25]};
    border-radius: 0.125rem;
  `,
  dash: (theme: Theme) => css`
    min-width: 1.25rem;
    min-height: 0.25rem;
    background-color: ${theme.palette.primary[25]};
    border-radius: 0.125rem;
  `,
};

type AnalyticsToggleProps = {
  compact: boolean;
  setCompact: (value: boolean) => void;
}

const AnalyticsToggle = ({ compact, setCompact }: AnalyticsToggleProps) => {
  const toggle = () => setCompact(!compact);
  return (
    <Stack direction="row" css={styles.handle} alignItems="center" justifyContent="center" gap={1} onClick={toggle}>
      {compact ? (
        <Box css={styles.dash} />
      ) : (
        <>
          <Box css={styles.dot} />
          <Box css={styles.dot} />
          <Box css={styles.dot} />
        </>
      )}
    </Stack>
  );
};

/*
<b>Last 24 hours:</b>
{data ? (
  <>
    {/*<AnalyticCard small={compact} title="Avg Wait" value={`${waitTime}m`} data={data.waittime.hourly} />*}
    <AnalyticCard small={compact} title="Patients" value={data.patients.num} data={data.patients.hourly} />
    <AnalyticCard small={compact} title="ATS 1" value={data.triage.num} data={data.triage.hourly} />
    <AnalyticCard small={compact} title="Expects" value={data.expects.num} data={data.expects.hourly} />
    <AnalyticCard small={compact} title="Distress" value={data.distress.num} critical={data.distress.num >= 1} data={data.distress.hourly} />
  </>
) : (
  <>
    <AnalyticsSkeletonCard small={compact}/>
    <AnalyticsSkeletonCard small={compact}/>
    <AnalyticsSkeletonCard small={compact}/>
    <AnalyticsSkeletonCard small={compact}/>
    <AnalyticsSkeletonCard small={compact}/>
  </>
)}
*/
const Analytics = () => {
  // const mockData = useMemo(() => createMockAnalytics(), []);
  // const mockResult = {
  //   data: mockData,
  // };

  // const { data } = WORK_OFFLINE ? mockResult : useAnalytics();
  const [compact, setCompact] = useLocalStorage("trier.home.analytics", true);

  // we want to round up
  // const waitTime = Math.ceil(data?.waittime.num ?? 0);

  // Analytics card hidden as we are temporarily turning off waiting time estimates until EDIS integration is working
  return (
    <>
      <Stack sx={styles.analytics} className={scrollable}>
        <Box css={styles.analyticsContainer(!!compact)}>
          {!compact && (
            <Stack direction="row" gap={2} alignItems="center">
              {/* Placeholder for future analytics cards */}
            </Stack>
          )}
          <NextObservationCard small={compact} />
        </Box>
      </Stack>
      <Box css={styles.container}>
        <AnalyticsToggle compact={!!compact} setCompact={setCompact} />
      </Box>
    </>
  );
};

export const Home = () => {
  return (
    <Stack flex={1} sx={{ minHeight: 0, height: "100%", overflow: "hidden" }}>
      <Analytics />
      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <PatientList />
      </Box>
    </Stack>
  );
};
